import React from 'react';
import xss from 'xss';
import { ViewMode } from '../../constants';

interface AboutProps {
  view: ViewMode;
  title: string;
  description: string;
  backgroundColor: string;
  titleColor: string;
  titleFontSize: number;
  titleFontFamily: string;
  bodyTextColor: string;
  bodyTextFontSize: number;
  bodyTextFontFamily: string;
  images: { url: string; alt: string; }[];
}

export const About = ({
  view,
  title,
  description,
  backgroundColor,
  titleColor,
  titleFontSize,
  titleFontFamily,
  bodyTextColor,
  bodyTextFontSize,
  bodyTextFontFamily,
  images
}: AboutProps) => {
  const isDesktop = view === ViewMode.DESKTOP;

  const titleStyle = {
    color: titleColor,
    fontSize: titleFontSize,
    fontFamily: titleFontFamily,
    fontWeight: 600,
  };

  const bodyStyle = {
    color: bodyTextColor,
    fontSize: bodyTextFontSize,
    fontFamily: bodyTextFontFamily,
  };

  if (isDesktop) {
    return (
      <div className="w-full py-12 px-8" style={{ background: backgroundColor }}>
        <div className="text-center mb-4 w-full break-words" style={{ ...titleStyle, overflowWrap: 'anywhere', wordBreak: 'break-word' }}>
          {title}
        </div>
        <div className="text-center mb-10 max-w-3xl mx-auto w-full break-words" style={{ ...bodyStyle, overflowWrap: 'anywhere', wordBreak: 'break-word' }} dangerouslySetInnerHTML={{ __html: xss(description) }} />
        <div className="flex justify-center gap-x-8">
          {images.map((image, idx) => (
            <img
              key={idx}
              src={image.url}
              alt={image.alt}
              className="w-64 h-72 rounded-2xl object-cover shadow"
            />
          ))}
        </div>
      </div>
    );
  }

  // Mobile view
  return (
    <div className="w-full py-8 px-4" style={{ background: backgroundColor }}>
      <div className="text-center mb-2" style={titleStyle}>
        {title}
      </div>
      <div className="text-center mb-6 w-full max-w-xs break-words overflow-x-hidden" style={{ ...bodyStyle, overflowWrap: 'anywhere', wordBreak: 'break-word' }} dangerouslySetInnerHTML={{ __html: xss(description) }} />
      <div className="flex justify-center gap-4">
        {images.map((image, idx) => (
          <img
            key={idx}
            src={image.url}
            alt={image.alt}
            className="w-24 h-28 rounded-2xl object-cover bg-white shadow"
          />
        ))}
      </div>
    </div>
  );
};
